
import QueryString from 'query-string'
import { Component, Vue, Ref } from 'vue-property-decorator'
import { NewsService, MediaService } from '@/services/index'
import { ICommonResponse } from '@/services'
import NewsTable from '@/components/news/newsTable.vue'
import TableHeader from '@/components/table_header/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

const mediaOption = [{
    key: 0,
    value: '媒体名'
}, {
    key: 1,
    value: '记者名'
}, {
    key: 2,
    value: '标题'
}, {
    key: 3,
    value: '标题和内容'
}]

const selfMediaOption = [{
    key: 0,
    value: '媒体名'
}, {
    key: 2,
    value: '标题'
}]

export interface recommendFnOption {
    id: number
    sucessFn: () => void
    failFn: (result: ICommonResponse) => void
}

export const recommendNews = async (option: recommendFnOption) => {
    const params = { id: option.id }
    const result = await NewsService.createRecommendNews(params)
    if (result.status === 200) {
        option.sucessFn && option.sucessFn()
        return
    }
    option.failFn && option.failFn(result)
}

@Component({
    name: 'NewList',
    components: {
        NewsTable,
        TableHeader,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private newsList = []
    private newsSort: number = 0
    private newsType: number = 0
    private searchType: any = 0
    private searchQuery: string = ''
    private reporterId: any = ''
    private mediaId: any = ''
    private mediaType: any = ''
    private pageIndex: number = 1
    private pageSize: number = 50
    private pageTotal: number = 0
    private todayCount: number = 0
    private loading: boolean = false
    private isRecommend = false
    private tableHeaderDecs: string = ''
    private mediaTypeOptions = [{
        key: 'media',
        value: '新闻媒体'
    }, {
        key: 'self_media',
        value: '自媒体'
    }]
    private nTypeOptions = []
    private sortOptions = [{
        key: 0,
        value: '最近创建'
    }, {
        key: 1,
        value: '最近更新'
    }, {
        key: 2,
        value: '最近发表'
    }]
    private mediasOptions = []

    get isSMedia() {
        return +this.mediaId > 10000000
    }
    get sTypeOptions() {
        return this.isSMedia ? selfMediaOption : mediaOption
    }

    private created() {
        const isRecommend = this.$route.query.recommend
        if (isRecommend) this.isRecommend = true
    }

    private mounted() {
        Promise.all([this.getNewsTypeOptions(), this.initData()])
    }

    private initData() {
        const rParams: any = QueryString.parse(location.search)
        if (rParams.reporterId) {
            this.reporterId = rParams.reporterId
            this.searchQuery = rParams.name
            this.searchType = 1   // 记者名类型
        }
        if (rParams.mediaId) {
            this.mediaId = rParams.mediaId
            this.searchQuery = rParams.name
            this.searchType = 0   // 媒体名类型
        }
        this.mediaType = !this.mediaId ? 'media' : (this.isSMedia ? 'self_media' : 'media')
        if (rParams.nTypeId) {
            const newsType: any = this.nTypeOptions.filter((newsType: any) => {
                // eslint-disable-next-line
                return newsType.id == rParams.nTypeId
            })
            this.newsType = newsType[0] ? newsType[0].key : ''
        }
        this.fetchNewsList()
    }

    private async getNewsTypeOptions() {
        const result = await NewsService.getFilterCondition()
        if (result.status === 200) {
            this.nTypeOptions = result.data
        }
    }

    private async fetchNewsList() {
        this.loading = true
        const params = {
            news_type: this.newsType,
            sort: this.newsSort,
            media_type: this.mediaType,
            search_type: this.searchType, 
            query: this.searchQuery,
            reporter_id: this.reporterId,
            media_id: this.mediaId,
            page_index: this.pageIndex, 
            page_size: this.pageSize 
        }
        const result = await NewsService.getList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.newsList = result.data.news_list
            this.todayCount = result.data.today_count
            this.tableHeaderDecs = '目前有 ' + this.pageTotal + ' 条，今日抓取 ' + 
            this.todayCount + ' 条'
        }
        this.loading = false
    }

    private async search() {
        this.newsSort = this.newsSort ? this.newsSort : 0
        this.reporterId = ''
        this.pageIndex = 1
        this.loading = true
        this.fetchNewsList()
    }

    private async querySuggestions(query: string) {
        const result = await MediaService.searchMedia({ value: query, media_type: this.mediaType })
        if (result.status === 200) {
            const medias = result.data.map((item: any) => {
                return { value: item.id, label: item.name }
            })
            this.mediasOptions = medias
        }
    }

    private onSTypeSelect() {
        // 从媒体切换到其他 需要把内容清空，推荐数组也清空。
        // 需要获取切换之前的值
        if (this.searchType === 0) {
            this.searchQuery = ''
            this.mediasOptions = []
        }
        this.mediaId = ''
    }

    private onSValueSelect(data: any) {
        this.mediaId = data.value
        this.searchQuery = data.label
    }

    private onCurrentChange(page: any) {
        this.pageIndex = page
        this.scrollEl.scrollToTop(this.fetchNewsList)
    }
    private onRecommend(news: any) {
        this.$confirm('将推荐该新闻到牛媒首页, 是否确定?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            recommendNews({
                id: news.id,
                sucessFn: () => {
                    this.$message({
                        type: 'success',
                        message: '推荐成功',
                        showClose: true
                    })
                },
                failFn: result => {
                    this.$message({
                        type: 'success',
                        message: result.message || '发生错误，推荐失败',
                        showClose: true
                    })
                }
            })
        })
    }

    private async recommendNews(id: number) {
        const params = { id }
        const result = await NewsService.createRecommendNews(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '推荐成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'success',
            message: result.message || '发生错误，推荐失败',
            showClose: true
        })
    }

    onChangeMediaType() {
        if (this.searchType === 1) {
            this.searchType = 0
            this.searchQuery = ''
            this.reporterId = ''
        }
    }
}
